<template>
  <v-list-item :loading="loading"
               :disabled="!isAberta"
               @click.stop="onClickCancel">
    <v-list-item-icon>
      <v-icon>mdi-cancel</v-icon>
    </v-list-item-icon>
    <v-list-item-content>Cancelar produto</v-list-item-content>
    <px-confirm-dialog ref="confirm"/>
  </v-list-item>
</template>

<script>
import { SituacoesCotacao } from 'px-business-components';
import CotacaoProdutoService from '@/modules/cotacao/cotacao-produto-service';

export default {
  props: {
    cotacao: Object,
    cotacaoProduto: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isAberta() {
      return SituacoesCotacao.ABERTAS.includes(this.cotacaoProduto.situacao);
    },
  },
  methods: {
    cancelar() {
      this.loading = true;
      CotacaoProdutoService.cancelar(this.cotacao.id, this.cotacaoProduto.id)
        .then(() => {
          this.$toast('Item cancelado com sucesso', { color: 'success' });
          this.$emit('update');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickCancel() {
      this.$refs.confirm.open('Você deseja cancelar este item?',
        'O item será cancelado e os fornecedores não poderão mais respondê-lo. Esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.cancelar();
        });
    },
  },
};
</script>
